document.addEventListener('DOMContentLoaded', () => {
  const initExclusiveShopAccordions = () => {
    const shopPanels = document.querySelectorAll('.header-sidebar__sub-panel--custom-shop');

    shopPanels.forEach((panel) => {
      const detailsItems = panel.querySelectorAll('.header-sidebar__shop-category');

      detailsItems.forEach((item) => {
        if (item.dataset.mmbExclusiveBound === 'true') return;

        item.dataset.mmbExclusiveBound = 'true';

        item.addEventListener('toggle', () => {
          if (!item.open) return;

          detailsItems.forEach((otherItem) => {
            if (otherItem !== item && otherItem.open) {
              otherItem.removeAttribute('open');
            }
          });
        });
      });
    });
  };

  initExclusiveShopAccordions();

  const observer = new MutationObserver(() => {
    initExclusiveShopAccordions();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});